/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Typeupdate2Inputs */

const id_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbarui`)
};

const ms_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas kini`)
};

const da_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdater`)
};

const de_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const en_us2_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const es_es2_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const es_mx2_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const fil_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const fr_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour`)
};

const it_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const hu_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frissítés`)
};

const nl_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const no_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppdater`)
};

const pl_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizacja`)
};

const pt_br2_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

const pt_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização`)
};

const ro_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizare`)
};

const fi_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitys`)
};

const sv_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdatering`)
};

const vi_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật`)
};

const tr_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncelle`)
};

const cs_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizace`)
};

const bg_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Актуализация`)
};

const ru_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление`)
};

const uk_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оновлення`)
};

const ar_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث`)
};

const hi_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट`)
};

const th_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดต`)
};

const ja_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const zh_cn2_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const zh_hant1_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const ko_offerdetail_changelog_typeupdate2 = /** @type {(inputs: Offerdetail_Changelog_Typeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업데이트`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Offerdetail_Changelog_Typeupdate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_typeupdate2 = /** @type {((inputs?: Offerdetail_Changelog_Typeupdate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Typeupdate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "da") return da_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "de") return de_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "it") return it_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "no") return no_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "th") return th_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_typeupdate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_typeupdate2(inputs)
	return ko_offerdetail_changelog_typeupdate2(inputs)
});
export { offerdetail_changelog_typeupdate2 as "offerDetail.changelog.typeUpdate" }